import { FC, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { useAuthContext } from '@/contexts';
import { enumController } from '@/apis/core';
import * as actions from '@/shared_elements/actions';

const SharedDataFetch: FC = () => {
  const { profile } = useAuthContext();
  const dispatch = useDispatch();

  const fetchSmsUseCases = async () => {
    const response = await enumController.getUsecaseTypes({
      channelId: 'SMS',
    });
    dispatch({
      type: actions.ADD_ENUM_SMS_USE_CASE,
      payload: response,
    });
  };

  const fetchVerticalTypes = async () => {
    const response = await enumController.getVerticalTypes();
    dispatch({
      type: actions.ADD_ENUM_VERTICAL_TYPE,
      payload: response,
    });
  };

  const fetchCountries = async () => {
    const response = await enumController.getCountries();
    dispatch({
      type: actions.ADD_ENUM_COUNTRY,
      payload: response,
    });
  };

  const fetchMnos = async () => {
    const response = await enumController.getMnos();
    dispatch({
      type: actions.ADD_ENUM_MNO,
      payload: response,
    });
  };

  const fetchData = async () => {
    if (!profile) {
      return;
    }

    const promises: Promise<unknown>[] =
      profile.market === 'HU'
        ? [
            fetchSmsUseCases(),
            fetchVerticalTypes(),
            fetchCountries(),
            fetchMnos(),
          ]
        : [];
    await Promise.allSettled(promises);
  };

  useEffect(() => {
    if (profile) {
      fetchData();
    }
  }, [profile]);

  return null;
};

export default SharedDataFetch;
